var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "market-container" },
    [
      _c("div", { staticClass: "container-responsive" }, [
        _c("div", { staticClass: "row pb-20" }, [
          _c("p", { staticClass: "heading" }, [_vm._v("Marketplace")]),
          _c(
            "div",
            { staticClass: "align-right col-md-7 col-lg-4 col-sm-7 col-xs-12" },
            [
              _c("p", { staticClass: "pr-8 mt-10" }, [_vm._v("Service Type")]),
              _c(
                "multiselect",
                {
                  staticClass:
                    "multiselect-dropdown multiselect-single-dropdown",
                  attrs: {
                    showLabels: false,
                    "close-on-select": true,
                    "allow-empty": false,
                    searchable: false,
                    options: _vm.servicesList,
                    placeholder: "Select Service",
                  },
                  on: { change: _vm.filterServices },
                  model: {
                    value: _vm.selectedService,
                    callback: function ($$v) {
                      _vm.selectedService = $$v
                    },
                    expression: "selectedService",
                  },
                },
                [
                  _c(
                    "span",
                    { attrs: { slot: "noResult" }, slot: "noResult" },
                    [_vm._v("No matching data")]
                  ),
                ]
              ),
            ],
            1
          ),
        ]),
        _vm.filterServices && _vm.filterServices.length
          ? _c(
              "div",
              { staticClass: "row" },
              [
                _c("div", { staticClass: "service-title" }, [
                  _vm._v("RAMS Services"),
                ]),
                _c("br"),
                _vm._l(_vm.filterServices, function (service, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass:
                        "service-card col-lg-3 col-md-4 col-sm-6 col-xs-12 pr-30 pl-0",
                    },
                    [
                      service.id === 1 || service.id === 4
                        ? _c(
                            "div",
                            { staticClass: "offer-content" },
                            [
                              !service.alreadyAdded &&
                              !service.trialEnded &&
                              !service.renewedService
                                ? [
                                    _c("img", {
                                      staticClass:
                                        "rectangle-icon emergo-rec-green",
                                      attrs: {
                                        src: "/static/images/icons/rectangle_banner.svg",
                                        alt: "rectangle-icon",
                                      },
                                    }),
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "free-text free-trial-text",
                                      },
                                      [_vm._v("Free Trial")]
                                    ),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          )
                        : _vm._e(),
                      service.id === 10 &&
                      _vm.todayDate() > _vm.renewStartDate() &&
                      _vm.todayDate() < _vm.renewEndDate()
                        ? _c("div", { staticClass: "offer-content" }, [
                            _c("img", {
                              staticClass: "rectangle-icon emergo-rec-blue",
                              attrs: {
                                src: "/static/images/icons/rectangle_banner.svg",
                                alt: "rectangle-icon",
                              },
                            }),
                            _c("p", { staticClass: "free-text free-text-pc" }, [
                              _vm._v("OFFER"),
                            ]),
                          ])
                        : _vm._e(),
                      _c("div", { staticClass: "market-card p-0" }, [
                        _c("div", { staticClass: "inner-card" }, [
                          _c("div", { staticClass: "market-heading" }, [
                            _c("img", {
                              staticClass: "market-img mb-16",
                              attrs: {
                                src: _vm.getBlobUrl(service.icon_location),
                                alt: "service-icon",
                              },
                            }),
                            _c("p", { staticClass: "card-title mb-16" }, [
                              _vm._v(_vm._s(service.name)),
                            ]),
                            _c("div", {
                              staticClass: "details-text mb-16",
                              domProps: {
                                innerHTML: _vm._s(service.description),
                              },
                            }),
                            _c(
                              "p",
                              {
                                staticClass: "learn-more",
                                on: {
                                  click: function ($event) {
                                    return _vm.learnMore(
                                      service.id,
                                      service.name
                                    )
                                  },
                                },
                              },
                              [_vm._v("Learn More")]
                            ),
                          ]),
                          (service.expiry_date || service.alreadyAdded) &&
                          ((service.id !== 6 && service.alreadyAdded) ||
                            (service.id === 6 &&
                              service.alreadyAdded &&
                              _vm.isProdClassServiceActive))
                            ? _c("div", { staticClass: "row" }, [
                                _c("hr", { staticClass: "separator" }),
                                _c(
                                  "div",
                                  { staticClass: "status" },
                                  [
                                    service.expiry_date
                                      ? [
                                          _c("img", {
                                            attrs: {
                                              src: "/static/images/icons/expiring_soon.svg",
                                              alt: "expiring soon",
                                            },
                                          }),
                                          _c("span", [
                                            _vm._v(
                                              "Expires on " +
                                                _vm._s(
                                                  _vm._f("UTCDate")(
                                                    service.expiry_date,
                                                    "DD MMM YYYY"
                                                  )
                                                )
                                            ),
                                          ]),
                                        ]
                                      : service.alreadyAdded
                                      ? [
                                          _c("img", {
                                            staticClass: "check-icon",
                                            attrs: {
                                              src: "/static/images/icons/check_icon.svg",
                                              alt: "active",
                                            },
                                          }),
                                          _c("span", [_vm._v("Active")]),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ]),
                    ]
                  )
                }),
              ],
              2
            )
          : _vm._e(),
        _vm.otherServices && _vm.otherServices.length
          ? _c(
              "div",
              { staticClass: "row" },
              [
                _c("div", { staticClass: "service-title" }, [
                  _vm._v("Affiliate SaaS Services"),
                ]),
                _c("br"),
                _vm._l(_vm.otherServices, function (service, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass:
                        "service-card col-lg-3 col-md-4 col-sm-6 col-xs-12 pr-30 pl-0",
                    },
                    [
                      service.id == 5
                        ? _c("div", { staticClass: "offer-content" }, [
                            _c("img", {
                              staticClass: "rectangle-icon emergo-rec-blue",
                              attrs: {
                                src: "/static/images/icons/rectangle_banner.svg",
                                alt: "rectangle-icon",
                              },
                            }),
                            _c("p", { staticClass: "free-text free-text-gg" }, [
                              _vm._v("PARTNER"),
                            ]),
                          ])
                        : _vm._e(),
                      service.id == 8
                        ? _c("div", { staticClass: "offer-content" }, [
                            _c("img", {
                              staticClass: "rectangle-icon emergo-rec-blue",
                              attrs: {
                                src: "/static/images/icons/rectangle_banner.svg",
                                alt: "rectangle-icon",
                              },
                            }),
                            _c("p", { staticClass: "free-text" }, [
                              _vm._v("UL LMS"),
                            ]),
                          ])
                        : _vm._e(),
                      service.id == 9
                        ? _c("div", { staticClass: "offer-content" }, [
                            _c("img", {
                              staticClass: "rectangle-icon emergo-rec-blue",
                              attrs: {
                                src: "/static/images/icons/rectangle_banner.svg",
                                alt: "rectangle-icon",
                              },
                            }),
                            _c(
                              "p",
                              { staticClass: "free-text free-text-opus" },
                              [_vm._v("EMERGO")]
                            ),
                          ])
                        : _vm._e(),
                      _c("div", { staticClass: "market-card p-0" }, [
                        _c("div", { staticClass: "inner-card" }, [
                          _c("div", { staticClass: "market-heading" }, [
                            _c("img", {
                              staticClass: "market-img mb-16 width-23",
                              class: { "icon-opus": service.id === 9 },
                              attrs: {
                                src: _vm.getBlobUrl(service.icon_location),
                                alt: "service-icon",
                              },
                            }),
                            _c("p", { staticClass: "card-title mb-16" }, [
                              _vm._v(_vm._s(service.name)),
                            ]),
                            _c("div", {
                              staticClass: "details-text mb-16",
                              domProps: {
                                innerHTML: _vm._s(service.description),
                              },
                            }),
                            _c(
                              "p",
                              {
                                staticClass: "learn-more",
                                on: {
                                  click: function ($event) {
                                    return _vm.learnMore(
                                      service.id,
                                      service.name
                                    )
                                  },
                                },
                              },
                              [_vm._v("Learn More")]
                            ),
                          ]),
                        ]),
                      ]),
                    ]
                  )
                }),
              ],
              2
            )
          : _vm._e(),
      ]),
      _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }